import React from "react";
import { compose, graphql } from "react-apollo";

import translateErrorMessage from "utils/translateErrorMessage";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import { USERS_QUERY } from "./userManagementQueries";
import { UPDATE_USER_MUTATION } from "./userManagementMutations";
import UserModal from "./UserModal";

class UserEdit extends React.Component {
  onSave = ({
    name, email, role, password, screenOverrides
  }) => {
    this.props.updateUser({
      variables: {
        id: this.props.user.id,
        params: {
          name,
          email,
          role,
          password,
          // The JSON scalar input is parsed from a string server-side.
          screenOverrides: screenOverrides ? JSON.stringify(screenOverrides) : null,
        }
      },
      refetchQueries: [{
        query: USERS_QUERY
      }]
    })
      .then(() => {
        this.props.snackbarContext.setNotificationTimeOut(Color.success, "Usuário atualizado.");
        this.props.onFinishEdit();
      })
      .catch(error => {
        this.props.snackbarContext.setNotificationTimeOut(Color.danger, translateErrorMessage(error));
      });
  }

  render() {
    return (
      <UserModal
        user={this.props.user}
        isOpen={this.props.isOpen}
        toggleModal={this.props.onFinishEdit}
        title="Editar usuário"
        onSave={this.onSave}
      />
    );
  }
}

export default compose(
  graphql(UPDATE_USER_MUTATION, { name: "updateUser", }),
  withSnackbarConsumer,
)(UserEdit);
